import { usersCollectorExtension } from "./users-collector-extension.js";
import { profilesCollectorExtension } from "./profiles-collector-extension.js";

export function registerCollectorExtensions(){
    usersCollectorExtension.registerElement();
    profilesCollectorExtension.registerElement();
}